// initial state
const initialState = {
    reportType: '',
    tableType: ''
}

// type
const CHANGE_REPORT_TYPE = 'CHANGE_REPORT_TYPE',
      CHANGE_TABLE_TYPE = 'CHANGE_TABLE_TYPE';

// reducers
const reportReducer = (state=initialState, action) => {
    switch(action.type){
        case 'CHANGE_REPORT_TYPE': return{
            ...state,
            reportType: action.payload,
        }
        case 'CHANGE_TABLE_TYPE': return{
            ...state,
            tableType: action.payload,
        }
        default: return state;
    }
}

// actions
const reportTypeAction = (reportType) => async (dispatch, getState) => {
    dispatch({
        type: CHANGE_REPORT_TYPE,
        payload: reportType
    })
}

const tableTypeAction = (tableType) => async (dispatch, getState) => {
    dispatch({
        type: CHANGE_TABLE_TYPE,
        payload: tableType
    })
}

// exports
export { reportTypeAction, tableTypeAction }

export default reportReducer;